import { RequiredIndicatorPlacement as Placement, RequiredIndicator } from '@wix/ambassador-forms-v4-form-http/types';
import { Node_Type } from '@wix/ricos/schema';
import classNames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import React, { useMemo } from 'react';
import { useTranslation } from '../../sdk/components';
import { useRicosTheme } from '../../theme/ricos-theme-utils';
import RicosViewer from '../ricos-viewer/ricos-viewer';
import styles from './field-rich-label.module.scss';
function requiredIndicatorText(requiredIndicatorType, t) {
    switch(requiredIndicatorType){
        case RequiredIndicator.ASTERISK:
            return '*';
        case RequiredIndicator.TEXT:
            return t('settings.required-indicator-text');
        default:
            return '';
    }
}
export const FieldRichLabel = ({ label, required, disabled, requiredIndicatorType = RequiredIndicator.ASTERISK, requiredIndicatorPlacement = Placement.AFTER_FIELD_TITLE, ricosTheme, requiredIndicatorClassName })=>{
    const customTheme = useRicosTheme(ricosTheme);
    const { t } = useTranslation();
    const indicator = requiredIndicatorText(requiredIndicatorType, t);
    const labelWithIndicator = useMemo(()=>{
        if (!required) {
            return label;
        }
        const str = (v)=>({
                stringValue: v
            });
        // Legacy schema allowed textData on any node; V2 ExternalNode has no
        // textData slot, but the renderer still reads it at runtime.
        const indicatorNode = {
            type: Node_Type.EXTERNAL,
            id: '',
            nodes: [],
            externalData: {
                fields: {
                    'aria-hidden': str('true'),
                    className: str(classNames(styles.indicator, requiredIndicatorClassName))
                }
            },
            textData: {
                text: indicator,
                decorations: []
            }
        };
        const result = cloneDeep(label);
        switch(requiredIndicatorPlacement){
            case Placement.BEFORE_FIELD_TITLE:
                const firstNode = result?.nodes.find(Boolean);
                if (firstNode) {
                    firstNode.nodes ??= [];
                    firstNode.nodes.unshift(indicatorNode);
                }
                break;
            case Placement.AFTER_FIELD_TITLE:
                const lastNode = result?.nodes?.findLast(Boolean);
                if (lastNode) {
                    lastNode.nodes ??= [];
                    lastNode.nodes.push(indicatorNode);
                }
                break;
        }
        return result;
    }, [
        required,
        requiredIndicatorClassName,
        indicator,
        label,
        requiredIndicatorPlacement
    ]);
    return useMemo(()=>/*#__PURE__*/ React.createElement(RicosViewer, {
            content: labelWithIndicator,
            className: classNames(styles.root, {
                [styles.disabled]: disabled,
                [styles.indicatorBeforeLabel]: requiredIndicatorPlacement === Placement.BEFORE_FIELD_TITLE,
                [styles.indicatorAfterLabel]: requiredIndicatorPlacement === Placement.AFTER_FIELD_TITLE
            }),
            customTheme: customTheme
        }), [
        disabled,
        requiredIndicatorPlacement,
        labelWithIndicator,
        customTheme
    ]);
};

//# sourceMappingURL=field-rich-label.js.map